module.exports = __webpack_public_path__ + "static/media/linkIcon.c28af463.svg";